const fileMap = {
  "1 Affiliation.pdf": require("./1 Affiliation.pdf"),
  "2 Deed of Trust.pdf": require("./2 Deed of Trust.pdf"),
  "3 COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED.pdf": require("./3 COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED.pdf"),
  "4 COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009.pdf": require("./4 COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009.pdf"),
  "5 COPY OF VALID BUILDING SAFETY CERTIFICATE.pdf": require("./5 COPY OF VALID BUILDING SAFETY CERTIFICATE.pdf"),
  "6 COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED.pdf": require("./6 COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED.pdf"),
  "7 Self Declaration.pdf": require("./7 Self Declaration.pdf"),
  "8 COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES.pdf": require("./8 COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES.pdf"),
  "9 FEE STRUCTURE OF THE SCHOOL.pdf": require("./9 FEE STRUCTURE OF THE SCHOOL.pdf"),
  "10 ANNUAL ACADEMIC CALENDER.pdf": require("./10 ANNUAL ACADEMIC CALENDER.pdf"),
  "11 LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION.pdf": require("./11 LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION.pdf"),
  "13 SARAS.pdf": require("./13 SARAS.pdf"),
  "14 LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS.pdf": require("./14 LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS.pdf"),
  "15  LIST OF SCHOOL MANAGEMENT COMMITTEE.pdf": require("./15  LIST OF SCHOOL MANAGEMENT COMMITTEE.pdf"),
  "16 LIST OF STAFFS.pdf": require("./16 LIST OF STAFFS.pdf")
};

export default fileMap;

